import React from "react";
import StopIcon from "@material-ui/icons/Stop";
import { ASIconButton } from "allegro-ui";
import { useSlotActions } from "src/xerver-room/hooks";

type Props = { slotId: string; disabled?: boolean };

export const XRStopSlotButton: React.FC<Props> = ({ slotId, disabled }) => {
  const slot = useSlotActions(slotId);
  return (
    <ASIconButton
      kind="secondary"
      size="small"
      disabled={disabled}
      onClick={() => {
        alert(`停止します(ID:${slotId})`);
        slot.requestStop();
      }}
    >
      <StopIcon />
    </ASIconButton>
  );
};
